export default {
  age: '0',
  weight: '0 lbs',
  desiredWeightLost: '0 lbs',
  waistCircumference: '0',
};
